export const staticLabelsSearch = {
  en: {
    searchResultsFor: "Search Results for",
    searchResults: "Search Results",
  },
  vn: {
    searchResultsFor: "Kết quả tìm kiếm cho",
    searchResults: "Kết quả tìm kiếm",
  },
};
